import { createMemoryHistory, createBrowserHistory } from 'history';

export interface HistoryParams {
  initialEntries?: any[];
  basename?: string;
}

export const createUniversalHistory = ({ initialEntries = [], basename }: HistoryParams = {}) => {
  if (__BROWSER__) {
    const history = window.browserHistory || createBrowserHistory({ basename });
    if (process.env.NODE_ENV === 'development' && !window.browserHistory) {
      window.browserHistory = history;
    }
    return history;
  }
  return createMemoryHistory({ initialEntries });
};

export default createUniversalHistory;
